import React from 'react'
import { Button, Popconfirm } from 'antd'
import { useTranslation } from 'next-i18next'
import { VintageItemPayload } from 'src/core/models'
import { DeleteOutlined, EditTwoTone } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  setProjectFormItemValue,
  vintageItemListSelector,
  projectDetailsSelector,
} from 'src/features'

interface VintageListActionsColumnProps { vintage: VintageItemPayload }

const VintageListActionsColumn: React.FC<VintageListActionsColumnProps> = ({ vintage }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const vintageList = useAppSelector(vintageItemListSelector)
  const { project: projectToEdit } = useAppSelector(projectDetailsSelector)
  const isDeleteButtonDisabled: boolean = (
    vintage.year && Boolean(projectToEdit?.vintage_items.find(vi => vi.year === vintage.year))
  )

  const handleEdit = () => {
    dispatch(setProjectFormItemValue({ key: 'currentVintage', value: vintage }))
  }

  const handleDelete = () => {
    const newVintageList = vintageList.filter(v => v.year !== vintage.year)
    dispatch(setProjectFormItemValue({ key: 'vintage_items', value: newVintageList }))
    dispatch(setProjectFormItemValue({ key: 'currentVintage', value: null }))
  }

  const deleteButton = <Button
    danger
    size='middle'
    shape='circle'
    disabled={isDeleteButtonDisabled}
    icon={<DeleteOutlined />}
  />

  return (
    <div className='has-text-centered'>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        onClick={handleEdit}
        icon={<EditTwoTone />}
      />
      &nbsp; &nbsp;
      {isDeleteButtonDisabled ? <>{deleteButton}</>: (
        <Popconfirm
          title={t('general.SureDelete')}
          onConfirm={handleDelete}
          okText={t('general.Yes')}
          cancelText={t('general.Cancel')}
        >
          {deleteButton}
        </Popconfirm>
      )}
    </div>
  )
}

export default VintageListActionsColumn
